import type { PropsWithChildren } from 'react'
import type { StyledThemedBackgroundHeaderProps } from './ThemedBackgroundHeader.styles'
import { StyledThemedBackgroundHeader } from './ThemedBackgroundHeader.styles'

export function ThemedBackgroundHeader(
  props: PropsWithChildren<StyledThemedBackgroundHeaderProps>
): JSX.Element {
  return <StyledThemedBackgroundHeader {...props} />
}
